<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="sms"/>
          {{ $t('aiHistory') }}
        </h1>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><router-link to="/">{{ $t('aiHistory') }}</router-link></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('waiting')"></b-tab>
          <b-tab :title="$t('sent')"></b-tab>
          <b-tab :title="$t('charged')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                :placeholder="$t('keyword')"></b-form-input>
            <client-select :model="filterFormModel" class="mr-1 mb-1" attribute="client" :isFilter="true" :place-holder="$t('selectClient') "></client-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
            <ai-export class="mb-1" :data="items"></ai-export>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" 
                class="pull-right"
                size="sm"
                v-model="filterFormModel.page" :total-rows="itemCount"
                :per-page="filterFormModel.pageSize"
                @input="load">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items && items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('client') }}</div>
            <div class="col-lg-5">{{ $t('info') }}</div>
            <div class="col-lg-3">{{ $t('status') }}</div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <div v-if="item.client">
                <div><b>{{ $t("companyName") }}: </b>{{ item.client.companyName }}</div>
                <div><b>{{ $t("domain") }}: </b>{{ item.client.domain }}</div>
                <div v-if="item.gateway"><b>{{ $t("gateway") }}</b>: {{ item.gateway.name }} ({{item.gateway.fee | numFormat}})</div>
              </div>
              <div v-else><span class="badge badge-success">{{$t('allClient')}}</span></div>
            </div>
            <div class="col-lg-5">
              <div><b>{{ $t("template") }}</b>: {{ item.template.name }}</div>
              <div><b>{{ $t("phone") }}: </b>{{ item.phone}}</div>
              <div v-if="item.chargeTime"><b>{{ $t("chargeTime") }}: </b>{{ item.chargeTime | moment('DD/MM/YYYY HH:mm:ss') }}</div>
              <p v-if="item.chargedFee">
                <b>{{ $t('fee') }}:&nbsp;</b><span class="text-danger">{{ item.chargedFee | numFormat }}<sup>{{ item.client.country.currency }}</sup></span>
              </p>
            </div>
            <div class="col-lg-3">
              <div>
                <label v-if="item.sendTime && item.chargeTime" class="badge badge-success">{{ $t('charged') }}</label>
                <label v-else-if="item.sendTime" class="badge badge-primary">{{ $t('sent') }}</label>
                <label v-else class="badge badge-warning">{{ $t('waiting') }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items || !items.length">
        <span>{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" 
          class="pull-right" size="sm"
          v-model="filterFormModel.page" :total-rows="itemCount"
          :per-page="filterFormModel.pageSize"
          @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import AIExport from './AIExport.vue';
import ClientSelect from "@/components/ClientSelect";

export default {
  mixins: [list, crud],
  components: {'ai-export': AIExport, ClientSelect},
  data: function () {
    return {
      service: '/ai',
      defaultFilterFormModel: {
        status: 0,
        client: null,
        gateway: null,
      }
    }
  },
  i18n: {
    messages: {
      en: {
        aiHistory: "Auto call: History",
        waiting: "Waiting",
        sent: "Sent",
        charged: "Charged",
        chargeTime: "Charged time",
        fee: "Fee",
        template: "Template",
        phone: "Phone",
      },
      vi: {
        aiHistory: "Gọi tự động: Lịch sử",
        waiting: "Đang đợi",
        sent: "Đã gửi",
        charged: "Đã thu phí",
        chargeTime: "Tính tiền lúc",
        fee: "Số tiền",
        template: "Mẫu cuộc gọi",
        phone: "Số gọi đến",
      }
    }
  }
}
</script>